"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusBoxShadow = void 0;
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const defaultBorder = `${theme_1.Border.size.default} solid ${theme_1.Border.color.default}`;
exports.focusBoxShadow = `0 0 0px 2px ${design_system_1.Colors.blue500}`;
const Styles = {
    StepCardBorder: {
        borderRadius: theme_1.Border.radius.large,
        border: defaultBorder,
    },
    DefaultBorder: defaultBorder,
    FocusedElement: {
        border: `${theme_1.Border.size.default} solid ${design_system_1.Colors.white}`,
        boxShadow: exports.focusBoxShadow,
        outline: 'none',
    },
};
exports.default = Styles;
